import React from 'react';
import styled from 'styled-components/macro';
import { RecurringModal, RecurringItem } from '../../components';
import {
  CustomReportItem,
  loadCustomReport,
  useCustomReportsContext,
} from 'lib/context';
import { Button } from 'react-covideo-common';
import { FiPlus } from 'react-icons/fi';

const Container = styled.div`
  margin-top: 24px;
`;

const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
`;

type Props = {
  customReport: CustomReportItem;
};

export const RecurringTab = (props: Props) => {
  const [showRecurringReportModal, setShowRecurringReportModal] =
    React.useState(false);

  const [customReport, setCustomReport] = React.useState<any>(
    props.customReport
  );
  const { dispatch } = useCustomReportsContext();

  const setCurrentCustomReport = async (reportId: string) => {
    const customReport = await loadCustomReport({ reportId, dispatch });
    setCustomReport(customReport);
  };
  const recurringArray = customReport.recurrings || [];

  return (
    <Container>
      <ActionButtons>
        <Button
          text='New Recurring'
          icon={<FiPlus size={20} />}
          onClick={() => setShowRecurringReportModal(true)}
        />
      </ActionButtons>
      <div>
        {recurringArray.map((recurring: any) => (
          <RecurringItem
            key={recurring.recurringId}
            reportId={customReport.reportId || ''}
            recurring={recurring}
            setCustomReport={setCurrentCustomReport}
          />
        ))}
        {!recurringArray.length && (
          <div style={{ textAlign: 'center' }}>No data to show.</div>
        )}
      </div>
      {showRecurringReportModal && (
        <RecurringModal
          reportId={customReport.reportId || ''}
          handleModalClose={() => setShowRecurringReportModal(false)}
          setCustomReport={setCurrentCustomReport}
        />
      )}
    </Container>
  );
};
